import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ClientModel extends BaseModel {
  @attr("string") email;
  @attr("string") name;
  @attr("string") namePrefix;
  @attr("string") phone;
  @attr("string") username;
  @attr("string") pk;
  @belongsTo("entity") entity;
}
